<template>
  <div>
    <div class="container">
      <div
        v-bind:class="{ itemActive: !isViewSetting, itemSelect: isViewSetting }"
        v-on:click="actionCtr('settingwindow')"
      >
        <span class="fa fa-wrench"></span>
        <span class="menutext">設定表示</span>
      </div>

      <div class="itemActive" v-if="!isMuteOn" v-on:click="actionCtr('mute')">
        <span class="fa fa-microphone"></span>
        <span class="menutext">ON</span>
      </div>
      <div class="itemSelect" v-if="isMuteOn" v-on:click="actionCtr('mute')">
        <span class="fa fa-microphone-slash"></span>
        <span class="menutext">OFF</span>
      </div>

      <div class="itemSelect" v-if="!isVideoOn" v-on:click="actionCtr('videoonoff')">
        <span class="fa fa-video-camera"></span>
        <span class="menutext">OFF</span>
      </div>
      <div class="itemActive" v-if="isVideoOn" v-on:click="actionCtr('videoonoff')">
        <span class="fa fa-video-camera"></span>
        <span class="menutext">ON</span>
      </div>

      <div class="itemActive" v-if="!isRequestShot" v-on:click="actionCtr('capture')">
        <span class="fa fa-camera"></span>
        <span class="menutext">キャプチャ</span>
      </div>
      <div class="itemDisable" v-if="isRequestShot">
        <span class="fa fa-paper-plane"></span>
        <span class="menutext">リクエスト中</span>
      </div>

      <div class="itemActive" v-if="isViewSendFile && sendIconMode==0" v-on:click="mdInpAux_img()">
        <span class="fa fa-file-text-o"></span>
        <span class="menutext">送信</span>
      </div>
      <div class="itemDisable" v-if="isViewSendFile && sendIconMode==1">
        <span class="fa fa-paper-plane"></span>
        <span class="menutext">送信中</span>
      </div>
      <div class="itemInfo" v-if="isViewSendFile && sendIconMode==2">
        <span class="fa fa-paper-plane"></span>
        <span class="menutext">完了</span>
      </div>

      <div
        v-bind:class="{ itemActive: isOtherVideo, itemSelect: !isOtherVideo }"
        v-on:click="actionCtr('othervideo')"
      >
        <span class="fa fa-file-video-o"></span>
        <span class="menutext">メインビュー</span>
      </div>
      <div class="itemActive" v-on:click="actionCtr('exit')">
        <span class="fa fa-sign-out"></span>
        <span class="menutext">退出</span>
      </div>
    </div>
    <form method="post" enctype="multipart/form-data" style="display:none">
      <input type="file" ref="img_inp" name="upload_img" @change="upload" />
    </form>
  </div>
</template>
<style scoped>
@media (max-width: 640px) {
  .menutext {
    display: none;
  }
}
.container {
  display: flex;
  justify-content: center;
}
.itemInfo {
  background-color: rgb(220, 74, 74);
  border: 1px solid white;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.itemActive {
  background-color: gray;
  border: 1px solid white;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.itemSelect {
  background-color: rgb(61, 61, 61);
  border: 1px solid gray;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.itemDisable {
  background-color: rgb(61, 61, 61);
  border: 1px solid gray;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  white-space: nowrap;
}
</style>

<script>
import ServerAccess from "@/api/serveraccess";
export default {
  name: "VideoCtr",
  data() {
    return {
      sendIconMode: 0,
      isViewSendFile: false,
    };
  },
  props: [
    "selectRoomId",
    "isViewSetting",
    "isRequestShot",
    "isVideoOn",
    "isMuteOn",
    "isSendFile",
    "isOtherVideo",
  ],
  mounted() {
    if (typeof process.env == "object") {
      this.isViewSendFile =
        process.env.HOLO_GYROEYE_FILELINK_SAVEURL != undefined &&
        process.env.HOLO_GYROEYE_FILELINK_LOGINURL != undefined;

      // fileタイプの許可
      let file = this.$refs.img_inp;
      let fileAccept = process.env.HOLO_GYROEYE_FILELINK_USE_FILEACCEPT;
      if (fileAccept && fileAccept.length > 0) {
        file.setAttribute("accept", fileAccept.join(","));
      }
    }
  },
  methods: {
    actionCtr(key) {
      this.$emit("action-ctr", key);
    },

    mdInpAux_img: function () {
      console.log("SELECT");
      this.$refs.img_inp.value = null;
      this.$refs.img_inp.click();
    },
    upload: function (e) {
      let file = this.$refs.img_inp.files[0];

      if (!file) {
        alert("ファイルが選ばれていません。再度ご確認ください。");
        return;
      }

      // ファイルサイズのチェック
      let limitSize = process.env.HOLO_GYROEYE_FILELINK_USE_FILESIZE;
      if (
        typeof limitSize == "number" &&
        limitSize != 0 &&
        file.size > limitSize
      ) {
        alert(
          Math.floor(limitSize / 1000000) +
            "MB以上のファイルは送信できません。再度ご確認ください。"
        );
        return;
      }

      // ファイルタイプの確認
      let fileAccept = process.env.HOLO_GYROEYE_FILELINK_USE_FILEACCEPT;
      let ext = file.name.substring(file.name.lastIndexOf("."));
      let typeAll = file.type.substring(0, file.type.lastIndexOf("/")) + "/*";

      if (
        fileAccept &&
        fileAccept.length > 0 &&
        fileAccept.indexOf(ext) == -1 &&
        fileAccept.indexOf(typeAll) == -1 &&
        fileAccept.indexOf(file.type) == -1
      ) {
        alert("送信が許可されていないファイルの種類です。再度ご確認ください。");
        return;
      }

      console.log(file);

      this.$emit("send-file", file);
    },
  },
  components: {},
  watch: {
    isSendFile: function (newData, oldData) {
      if (this.sendIconMode == 1 && oldData == true && newData == false) {
        this.sendIconMode = 2;
        setTimeout(() => {
          this.sendIconMode = 0;
        }, 2000);
      } else {
        this.sendIconMode = newData ? 1 : 0;
        // エラーなどの場合は自動で戻す
        setTimeout(() => {
          if (this.sendIconMode == 1) {
            this.sendIconMode = 0;
          }
        }, 15000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/VideoCtr.vue